import * as planGroup from './_planGroupCode'

export enum MedicalRequestTypeEnum {
  MEDICAL_REQUEST = 'medicalRequest',
  AUTHORIZATION_GUIDE = 'authorizationGuide',
}

export const planGroupsSettings = {
  [planGroup.CAREPLUS_PLAN_GROUP_CODE]: {
    daysToAuthorizeProcedure: 10,
    medicalRequest: {
      enabled: true,
      required: false,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '111111111111',
      placeholder: 'Código Careplus (12 dígitos)',
    },
  },

  [planGroup.CASSI_PLAN_GROUP_CODE]: {
    daysToAuthorizeProcedure: 5,
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '1111111111111111',
      placeholder: 'Código CASSI (16 dígitos)',
    },
    diseaseInfo: {
      cid: true,
      placeholder: 'Número do CID',
      helperText: true,
    },
    doctorInfo: {
      crm: true,
      uf: true,
    },
    hasSolicitationType: true,
  },

  [planGroup.SAMI_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '1111111111111111111',
      placeholder: 'Carteirinha (19 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.CUIDAR_OMINT_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar avaliação técnica',
      solicitationText:
        '*A avaliação técnica é obrigatória para a criação de uma nova solicitação de Terapia (50000470). Caso não exista, o profissional deverá emitir o documento.',
      helperText: true,
    },
    identifier: {
      mask: '1111111111111',
      placeholder: 'Carteirinha (13 dígitos)',
    },
  },

  [planGroup.OMINT_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar avaliação técnica',
      solicitationText:
        '*A avaliação técnica é obrigatória para a criação de uma nova solicitação de Terapia (50000470). Caso não exista, o profissional deverá emitir o documento.',
      helperText: true,
    },
    identifier: {
      mask: '11111111.11.11.1',
      placeholder: 'Código Omint (13 dígitos)',
    },
  },

  [planGroup.PROGRAMA_VIVA_PLAN_GROUP_CODE]: {
    plansPlaceholder: 'Medicamento'
  },

  [planGroup.BRADESCO_SAUDE_PLAN_GROUP_CODE]: {
    plansPlaceholder: 'Tipo de rede',
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText:
        '*O pedido médico com CID é obrigatório para a criação de uma nova solicitação Bradesco. Caso não possua, o paciente deverá procurar um médico e obter o encaminhamento.',
      helperText: true,
    },
    identifier: {
      mask: '111111111111111',
      placeholder: 'Carteirinha (15 dígitos)',
    },
    diseaseInfo: {
      cid: true,
      placeholder: 'Número do CID',
      helperText: true,
    },
    doctorInfo: {
      crm: true,
      uf: true,
    },
    hasSolicitationType: true,
    daysToAuthorizeProcedure: 5
  },

  [planGroup.BRADESCO_SEGUROS_PLAN_GROUP_CODE]: {
    plansPlaceholder: 'Tipo de rede',
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText:
        '*O pedido médico com CID é obrigatório para a criação de uma nova solicitação Bradesco. Caso não possua, o paciente deverá procurar um médico e obter o encaminhamento.',
      helperText: true,
    },
    identifier: {
      mask: '111111111111111',
      placeholder: 'Carteirinha (15 dígitos)',
    },
    diseaseInfo: {
      cid: true,
      placeholder: 'Número do CID',
      helperText: true,
    },
    doctorInfo: {
      crm: true,
      uf: true,
    },
    hasSolicitationType: true,
    daysToAuthorizeProcedure: 5
  },


  [planGroup.SAUDEID_PLAN_GROUP_CODE]: {
    plansPlaceholder: 'Tipo de plano',
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText:
        '*O pedido médico com CID é obrigatório para a criação de uma nova solicitação Saúde Id. Caso não possua, o paciente deverá procurar um médico e obter o encaminhamento.',
      helperText: true,
    },
    identifier: {
      placeholder: 'Número da carteirinha',
    },
    diseaseInfo: {
      cid: true,
      placeholder: 'Número do CID',
      helperText: true,
    },
    doctorInfo: {
      crm: true,
      uf: true,
    },
    hasSolicitationType: true,
  },

  [planGroup.SOMPO_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar avaliação técnica',
      solicitationText:
        '*A avaliação técnica é obrigatória para a criação de uma nova solicitação de Terapia (50000470). Caso não exista, o profissional deverá emitir o documento.',
      helperText: true,
    },
    identifier: {
      mask: '111111111111111111',
      placeholder: 'Carteirinha (18 dígitos)',
    },
  },

  [planGroup.MEDISERVICE_PLAN_GROUP_CODE]: {
    plansPlaceholder: 'Tipo de plano',
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText:
        '*O pedido médico com CID é obrigatório para a criação de uma nova solicitação Mediservice. Caso não possua, o paciente deverá procurar um médico e obter o encaminhamento.',
      helperText: true,
    },
    identifier: {
      mask: '111111111111111111',
      placeholder: 'Carteirinha (18 dígitos)',
    },
    diseaseInfo: {
      cid: true,
      placeholder: 'Número do CID',
      helperText: true,
    },
    doctorInfo: {
      crm: true,
      uf: true,
    },
    hasSolicitationType: true,
  },

  [planGroup.UNIMED_ANHANGUERA_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '11111111111111111',
      placeholder: 'Carteirinha (17 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.UNIMED_BOTUCATU_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '11111111111111111',
      placeholder: 'Carteirinha (17 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.UNIMED_FRANCA_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      type: MedicalRequestTypeEnum.AUTHORIZATION_GUIDE,
      placeholder: 'Anexar a guia de autorização',
      solicitationText: null,
      helperText: 'A guia de autorização é obrigatória. Caso não possua, fale com o time de atendimento da Unimed Franca para obter uma.',
      authorizationGuideNumbers: {
        placeholder: 'Números da guia de autorização',
        helperText: 'Os números constam na guia de autorização. Digite cada um deles atentamente.',
      },
    },
    identifier: {
      mask: '11111111111111111',
      placeholder: 'Carteirinha (17 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.UNIMED_LONDRINA_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '11111111111111111',
      placeholder: 'Carteirinha (17 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.UNIMED_NOROESTE_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '11111111111111111',
      placeholder: 'Carteirinha (17 dígitos)',
    },
    hasSolicitationType: true,
  },

  [planGroup.ALICE_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '11111111111',
      placeholder: 'CPF (Somente números)',
    },
    hasSolicitationType: true,
    useCpfInCardNumber: true,
    daysToAuthorizeProcedure: 5,
  },

  [planGroup.SANTA_HELENA_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    identifier: {
      mask: '111111111',
      placeholder: 'Carteirinha (9 dígitos)',
    },
    hasSolicitationType: true,
    daysToAuthorizeProcedure: 5,
  },

  [planGroup.PMESP_PLAN_GROUP_CODE]: {
    medicalRequest: {
      enabled: true,
      required: true,
      placeholder: 'Anexar pedido médico',
      solicitationText: null,
      helperText: null,
    },
    hasSolicitationType: true,
    useCpfInCardNumber: true,
  },
}

export const plansType = {
  PARTICULAR: 'particular',
  CAREPLUS: 'care-plus',
  CORPORATE: 'corporate', // empresas como Zup, Dextra
  ENTERPRISE: 'enterprise', // seguradoras como Bradesco, Omint,
  CAPITATION: 'capitation',
}

export enum PlanGroupCategoryEnum {
  CORPORATE_LIMITED = 'CORPORATE_LIMITED',
  CORPORATE_UNLIMITED = 'CORPORATE_UNLIMITED',
  ENTERPRISE = 'ENTERPRISE',
  PARTICULAR = 'PARTICULAR',
  CARE_PLUS = 'CARE_PLUS',
  VITTA = 'VITTA',
  CAPITATION = 'CAPITATION'
}
